import i18n from "~/i18n";

export const INVEST_TYPE = {
	ACCELERATOR: i18n.t("common.constants.form.accelerator"),
	VC: "VC",
	ANGEL: i18n.t("common.constants.form.angel"),
};

export const GET_TITLE = {
	"": i18n.t("common.constants.form.login"),
	join: i18n.t("common.constants.form.join"),
	joinconfirm: i18n.t("common.constants.form.join"),
	dashboard: i18n.t("common.constants.form.dashboard"),
	vcinfo: i18n.t("common.constants.form.vcInfo"),
	vcmember: i18n.t("common.constants.form.vcMember"),
	portfoliolist: i18n.t("common.constants.form.portfolioList"),
	investlist: i18n.t("common.constants.form.investList"),
	investevaluate: i18n.t("common.constants.form.investEvaluate"),
	investsetting: i18n.t("common.constants.form.investSetting"),
	roundlist: i18n.t("common.constants.form.roundList"),
	roundmanagement: i18n.t("common.constants.form.roundManagement"),
	roundregister: i18n.t("common.constants.form.roundRegister"),
	roundsetting: i18n.t("common.constants.form.roundSetting"),
	applylist: i18n.t("common.constants.form.applyList"),
	applyevaluate: i18n.t("common.constants.form.applyEvaluate"),
	applymanagement: i18n.t("common.constants.form.applyManagement"),
	applysetting: i18n.t("common.constants.form.applySetting"),
	myPagealarm: i18n.t("common.constants.form.myPageAlarm"),
	myPageplugin: i18n.t("common.constants.form.myPagePlugin"),
	myPageadmin: i18n.t("common.constants.form.myPageAdmin"),
};

export const LICENSE_PERIOD = {
	month: { date: "월", money: 11000 },
};

export const DAY_TYPE = {
	0: "일",
	1: "월",
	2: "화",
	3: "수",
	4: "목",
	5: "금",
	6: "토",
};
